import Header from "../../../layout/Header/Header";
import MultiRoute from "../../../common/MultiRoute/MultiRoute";
import Footer from "../../../layout/Footer/Footer";

import Breadcrumbs from "../../../common/Breadcrumbs/Breadcrumbs";

import {
    getAvailableTypesForLeaderThunkAction,
} from "../../../../redux/actions/Requests/RequestsFromLeader/thunk/getAvailableTypesForLeader.thunk.action";

import NavMenuDiv from "../../../common/NavMenuDiv/NavMenuDiv";

import { mode } from "../../../../app/mode";

import CustomLoader from "../../../common/CustomLoader/CustomLoader";

import {
    clearActiveDelegations,
} from "../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/clearActiveRequestsDelegations.action";

import {
    getActiveRequestDelegations,
} from "../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/getActiveDelegations.thunk.action";
import { getAllRequests } from "../../../../redux/actions/Requests/thunk/getAllRequests.thunk.action";

import { divisions } from "../../MyDivision/DivisionStructure/divisionStructure.data";

import { applicationsData } from "../../MyDivision/DivisionStructure/RequestDelegation/applications.data";

import editIcon from "../../MyDivision/DivisionStructure/RequestDelegation/Vector-1.png";

import deleteIcon from "../../../../assets/icons/delete_plus.svg";

import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import React from "react";
import moment from "moment/moment";


import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";


const LeaderRequestsPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const requestTypes = useSelector(state =>
        state.requests.categories?.find(el => el.type === 3)?.types ?? []);
    const requestsDelegations = useSelector(state => state.myDivision.requestsDelegations);

    const [loader, setLoader] = useState(false);
    function isDateInRange(date, startDate, endDate) {
        const startOfStartDate = new Date(startDate);
        startOfStartDate.setHours(0, 0, 0, 0);

        date.setHours(0, 0, 0, 0);

        const endOfEndDate = new Date(endDate);
        endOfEndDate.setHours(0, 0, 0, 0);

        return date >= startOfStartDate && date <= endOfEndDate;
    }

    useEffect(() => {
        dispatch(getActiveRequestDelegations({option: "delegate"}));
        dispatch(getAllRequests({setLoader: setLoader}));

        return()=>{
            dispatch(clearActiveDelegations());
        };
        // dispatch(unsetUserRequestAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Header />
            <Breadcrumbs />
            <div style={{ marginBottom: "20px" }}  className={"sub-header"}>Заявки руководителя</div>
            <div style={{ minHeight: "35vh", width: "1160px", margin: "0 auto" }}>
                {loader ? <CustomLoader /> :
                    (
                        <div style={{display: "flex", flexDirection: "column", gap: "40px"}}>
                            {  requestTypes &&
                            requestTypes.length !== 0
                                ?
                                <>
                                    <MultiRoute
                                        // breadCrumbs={true}
                                        // subHeader={"Заявки руководителя"}
                                        styleParent={"leader-requests"}
                                        data={requestTypes}
                                    />
                                    {/*{*/}
                                    {/*    mode !== "PROD" ?*/}
                                    {/*        <div>*/}
                                    {/*            <div*/}
                                    {/*                className={"leader-requests__item"}*/}
                                    {/*                onClick={()=>navigate("/main/hr-services/requests/leader/30")}*/}
                                    {/*            >*/}
                                    {/*                <div*/}
                                    {/*                    className={"leader-requests__block-head"}*/}
                                    {/*                >*/}
                                    {/*                    <div>Установление индивидуальных коэффициентов</div>*/}
                                    {/*                </div>*/}

                                    {/*            </div>*/}
                                    {/*        </div> : null*/}
                                    {/*}*/}

                                </>



                                : <div style={{ margin: "60px auto", width: "1160px" }}>

                                    <div style={{ margin: "auto", fontSize: "24px", lineHeight: "32px", color: "gray" }}>

                                        На данный момент нет доступных заявок руководителя
                                    </div>

                                </div>}
                            {
                                requestsDelegations && requestsDelegations.length > 0 ?
                                    <table className="table">
                                        <thead>
                                            <tr className="table__row">
                                                {applicationsData && applicationsData.map((el) => {
                                                    return (
                                                        <th
                                                            key={el.id}
                                                            style={{ width: `${el.width}`,  textAlign: "center" }}
                                                            className="delegation-of-responsibilities__rows__item"
                                                        >
                                                            {el.title}
                                                            {
                                                                el.icon
                                                                    ? <img
                                                                        src={el.icon}
                                                                        alt="triangle"
                                                                        className="header-triangle" />
                                                                    : null
                                                            }
                                                        </th>
                                                    );
                                                })
                                                }
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {requestsDelegations && requestsDelegations.map((el, i) => (
                                                <tr
                                                    key={el.id}
                                                    className={
                                                        isDateInRange(new Date(), el.from, el.to) ?
                                                            "delegation-of-responsibilities__rows-active" :
                                                            "delegation-of-responsibilities__rows"
                                                    }
                                                >
                                                    <td style={{ width:  "150px" }}>{el.initiator.fullName}</td>
                                                    <td style={{ width:  "150px", textAlign: "center"  }}>{el.initiator.jobTitle}</td>
                                                    <td style={{ width:  "150px" }}>{el.delegate.fullName}</td>
                                                    <td style={{ width:  "150px", textAlign: "center"  }}>{el.delegate.jobTitle}</td>
                                                    <td style={{ width:  "170px" }}>
                                                        {el.applicationTypes.map((e, index) => {
                                                            return (
                                                                <span key={e.id}>
                                                                    { index !== (el.applicationTypes.length - 1) ? `${ e.name }, ` : `${ e.name }` }
                                                                </span>
                                                            );
                                                        })}
                                                    </td>

                                                    <td style={{ width:  "108px", textAlign: "center"   }}>{moment(el.from).format("DD.MM.YYYY")}</td>
                                                    <td  style={{ width:  "108px", textAlign: "center" }}>
                                                        {el.to ?  moment(el.to).format("DD.MM.YYYY") : <div style={{fontSize: "26px", fontWeight: "lighter", textAlign: "center"}}>{"\u221E"}</div>  }

                                                    </td>
                                                    <td
                                                        // onClick={(e) => e.stopPropagation()}
                                                        style={{ width:  "60px" }}>
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    : null
                            }
                        </div>
                    )
                }


            </div>

            <Footer />
        </>
    );
};

export default LeaderRequestsPage;
